export default {
  getScrollTop: () => document.scrollingElement.scrollTop
}